// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2obHZ","item":"PaymentsMobile_item__2wvYo","label":"PaymentsMobile_label__3YwPE","amount":"PaymentsMobile_amount__1uMBv"};